<template>
    <div class="form">
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex>
                        <v-layout row>
                            <div class="info-block">
                                Change Password
                            </div>
                        </v-layout>
                        <div v-if="!checkAzureADLicence()">
                            <v-layout row v-if="errors !== null">
                                <v-flex md12>
                                    <div class="content-wrapper">
                                        <div class="error-block">
                                            <div class="title">Errors</div>
                                            <p v-html="errors"></p>
                                        </div>
                                    </div>
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs5>
                                    <div class="label text-xs-right">
                                        <span class="text-xs-right">Current password <span class="required">*</span></span>
                                    </div>
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field
                                        v-model="form.currentPassword"
                                        label="Insert password"
                                        :append-icon="showCurrentPassword ? 'visibility' : 'visibility_off'"
                                        :type="showCurrentPassword ? 'text' : 'password'"
                                        required
                                        outline
                                        single-line
                                        @click:append="showCurrentPassword = !showCurrentPassword"
                                        @keyup="validatePasswords"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs5>
                                    <div class="label text-xs-right">
                                        <span class="text-xs-right">New password <span class="required">*</span></span>
                                    </div>
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field
                                        v-model="form.newPassword"
                                        label="Insert new password"
                                        :rules="rules.password"
                                        :append-icon="showNewPassword ? 'visibility' : 'visibility_off'"
                                        :type="showNewPassword ? 'text' : 'password'"
                                        required
                                        outline
                                        single-line
                                        @click:append="showNewPassword = !showNewPassword"
                                        @keyup="validatePasswords"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs5>
                                    <div class="label text-xs-right">
                                        <span class="text-xs-right">Confirm new password <span class="required">*</span></span>
                                    </div>
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field
                                        v-model="rePassword"
                                        label="Repeat password"
                                        :append-icon="showRePassword ? 'visibility' : 'visibility_off'"
                                        :type="showRePassword ? 'text' : 'password'"
                                        required
                                        outline
                                        single-line
                                        @click:append="showRePassword = !showRePassword"
                                        @keyup="validatePasswords"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </div>
                        <v-layout row class="buttons">
                            <v-flex v-if="!checkAzureADLicence()" xs7 class="right text-xs-right">
                                <sp-button @click.native="validate" :loading="isLoading" text="Save" icon="download"></sp-button>
                            </v-flex>
                            <v-flex v-else>
                                <span class="text-xs-right"> Users from organizations with Azure Active Directory licence are able to change password by clicking: <a :href="azureADChangePasswordUrl">Change Password</a> </span>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>
    </div>
</template>

<script>
import SpButton from '@/components/forms/Button'

export default {
    name: 'ProfilePassword',
    components: {
        SpButton
    },
    props: {
        handler: {
            type: Function,
            required: true
        },
        form: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            valid: false,
            errors: null,
            rePassword: '',
            showNewPassword: false,
            showRePassword: false,
            showCurrentPassword: false,
            isLoading: false,
            rules: {
                password: [
                    v => (v && v.length && 8 <= v.length && 15 >= v.length) || 'Password must be at least 8 and less than 15 characters',
                    v => this.passwordValidator(v) || 'Password must contain at least 1 number, 1 lowercase letter and 1 uppercase letter',
                    v => (v && v.length && v === this.rePassword) || 'New password and confirm new password must be the same.',
                    v => (v && v.length && v !== this.form.currentPassword) || 'New password cannot be the same as current password.'
                ]
            }
        }
    },
    computed: {
        azureADChangePasswordUrl() {
            return `${process.env.VUE_APP_OIDC_AUTHORITY}account/manage?clientId=${process.env.VUE_APP_OIDC_CLIENT_ID}&returnUrl=${process.env.VUE_APP_OIDC_REDIRECT_URI}`
        }
    },
    mounted () {
    },
    methods: {
        async validate () {
            this.valid = this.$refs.form.validate()
            if (!this.valid) {
                return false
            }
            this.isLoading = true

            try {
                this.errors = null
                await this.handler(this.form)
            } catch (e) {
                this.errors = e.message
            }
            this.isLoading = false
            this.rePassword = null
        },
        validatePasswords () {
            this.valid = this.$refs.form.validate()
        },
        passwordValidator (password) {
            let re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,15}$)/
            return re.test(password)
        }
    }
}
</script>

<style scoped>
.form {
    width: 100%;
}
</style>
